<template>
  <v-dialog v-model="active">
    <div class="message-wrapper primary mainBorderColor">
      <div
          class="close-dialog"
          @click="closePopup"
      >
        <img
            alt="close-icon"
            src="../../assets/img/close.svg"
        />
      </div>
      <svg
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M52.7 11.6871H43.5048V10.1575C43.5048 8.00553 42.828 6.44553 41.46 5.49353C40.4936 4.86953 39.2952 4.55273 37.9016 4.55273H27.596C27.588 4.55273 27.5816 4.55753 27.5736 4.55753C27.5656 4.55753 27.5592 4.55273 27.5512 4.55273H26.0968C22.4824 4.55273 20.492 6.54313 20.492 10.1575V11.6871H11.3016C10.9833 11.6871 10.6781 11.8136 10.453 12.0386C10.228 12.2636 10.1016 12.5689 10.1016 12.8871C10.1016 13.2054 10.228 13.5106 10.453 13.7357C10.6781 13.9607 10.9833 14.0871 11.3016 14.0871H12.3368L15.4504 55.3431C15.4504 57.9527 16.9624 59.4487 19.6008 59.4487H44.3384C46.916 59.4487 48.4296 57.9607 48.4856 55.4327L51.6008 14.0871H52.6984C52.8559 14.0872 53.012 14.0563 53.1576 13.9961C53.3033 13.9359 53.4356 13.8476 53.5471 13.7362C53.6586 13.6249 53.7471 13.4926 53.8075 13.3471C53.8679 13.2015 53.8991 13.0455 53.8992 12.8879C53.8993 12.7303 53.8683 12.5743 53.8081 12.4287C53.7479 12.283 53.6596 12.1507 53.5483 12.0392C53.4369 11.9277 53.3047 11.8392 53.1591 11.7788C53.0136 11.7184 52.8575 11.6872 52.7 11.6871ZM49.0168 16.4487H14.9224L14.7448 14.0871H49.1944L49.0168 16.4487ZM22.8936 10.1575C22.8936 7.88073 23.8216 6.95273 26.0984 6.95273H37.9032C38.828 6.95273 39.588 7.13993 40.1256 7.48553C40.7864 7.94473 41.1064 8.81833 41.1064 10.1575V11.6871H22.8936V10.1575ZM46.0904 55.3159C46.06 56.6119 45.6184 57.0487 44.3384 57.0487H19.6008C18.292 57.0487 17.8504 56.6183 17.8472 55.2519L15.1032 18.8471H48.8344L46.0904 55.3159Z"
            fill="#92939C"
        />
        <path
            d="M27.842 20.7511C27.6846 20.7567 27.5298 20.7932 27.3865 20.8587C27.2433 20.9241 27.1143 21.0171 27.007 21.1324C26.8997 21.2478 26.8162 21.3831 26.7613 21.5307C26.7063 21.6783 26.681 21.8353 26.6868 21.9927L27.8132 52.9591C27.8244 53.2693 27.9553 53.563 28.1784 53.7787C28.4016 53.9944 28.6996 54.1153 29.01 54.1159L29.0548 54.1143C29.2122 54.1087 29.367 54.0722 29.5102 54.0068C29.6535 53.9413 29.7825 53.8483 29.8898 53.733C29.9971 53.6177 30.0806 53.4823 30.1355 53.3347C30.1904 53.1871 30.2158 53.0301 30.21 52.8727L29.0852 21.9047C29.0612 21.2423 28.5204 20.6935 27.842 20.7511ZM20.4036 20.7527C20.0862 20.7749 19.7906 20.9221 19.5818 21.1622C19.373 21.4022 19.268 21.7153 19.29 22.0327L21.4164 52.9991C21.4371 53.302 21.572 53.5858 21.7938 53.7931C22.0157 54.0005 22.3079 54.1158 22.6116 54.1159L22.6964 54.1127C23.0138 54.0906 23.3094 53.9433 23.5182 53.7033C23.727 53.4632 23.832 53.1501 23.81 52.8327L21.6836 21.8663C21.659 21.5499 21.511 21.2558 21.2716 21.0475C21.0321 20.8392 20.7204 20.7333 20.4036 20.7527ZM36.058 20.7511C35.3876 20.6871 34.8388 21.2439 34.8164 21.9063L33.6884 52.8727C33.6824 53.0302 33.7076 53.1873 33.7624 53.335C33.8173 53.4827 33.9008 53.6181 34.0081 53.7334C34.1154 53.8488 34.2445 53.9418 34.3879 54.0072C34.5312 54.0725 34.6861 54.109 34.8436 54.1143L34.8884 54.1159C35.1987 54.1153 35.4968 53.9944 35.7199 53.7787C35.9431 53.563 36.074 53.2693 36.0852 52.9591L37.2132 21.9927C37.2192 21.8353 37.194 21.6782 37.1391 21.5305C37.0843 21.3828 37.0008 21.2474 36.8934 21.132C36.7861 21.0166 36.6571 20.9236 36.5137 20.8582C36.3703 20.7929 36.2155 20.7565 36.058 20.7511ZM43.4964 20.7527C43.1797 20.7337 42.8682 20.8397 42.6288 21.048C42.3895 21.2562 42.2414 21.55 42.2164 21.8663L40.09 52.8327C40.068 53.1501 40.173 53.4632 40.3818 53.7033C40.5906 53.9433 40.8862 54.0906 41.2036 54.1127L41.2884 54.1159C41.5919 54.1154 41.884 53.9999 42.1058 53.7927C42.3275 53.5855 42.4625 53.3019 42.4836 52.9991L44.61 22.0327C44.632 21.7153 44.527 21.4022 44.3182 21.1622C44.1094 20.9221 43.8138 20.7749 43.4964 20.7527Z"
            fill="#92939C"
        />
      </svg>
      <h2 class="message-wrapper-title textMainColor">{{ $t('Delete') }} API</h2>
      <p class="message-wrapper-text">{{ $t('Are you sure you want to delete API?') }}</p>
      <p class="message-wrapper-key">{{ apiKey }}</p>
      <div class="buttons-wrapper">
        <button
            class="btn-cancel"
            type="button"
            @click="closePopup"
        >{{ $t('Cancel') }}
        </button>
        <button
            class="btn-delete"
            type="button"
        >{{ $t('Delete') }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'DeleteApi',
  data() {
    return {
      active: false,
    };
  },
  props: {
    apiKey: {
      type: String,
      required: true,
    },
  },
  methods: {
    openPopup() {
      this.active = true;
    },
    closePopup() {
      this.active = false;
    },
  },
};
</script>
<style scoped>
.message-wrapper {
  padding: 55px 30px 20px;
  text-align: center;
  position: relative;
  margin: 0 auto;
  border: 1px solid;
  border-radius: 8px;
  max-width: 460px;
}

.message-wrapper-title {
  margin-bottom: 15px;
  font-size: 20px;
  text-align: center;
}

.message-wrapper-text {
  font-size: 12px;
  color: #92939c;
}

.message-wrapper-key {
  margin-bottom: 25px;
  font-weight: 700;
  word-wrap: break-word;
}

.buttons-wrapper button {
  transition: background-color 0.5s;
  border-radius: 6px;
  width: calc(50% - 10px);
  padding: 12px 0;
  color: #fff;
}

.btn-cancel {
  margin-right: 20px;
  background-color: #454545;
}

.btn-delete {
  background-color: #f27870;
}

.v-application .v-dialog .btn-cancel:hover {
  background-color: #3f3f3f !important;
}

.btn-delete:hover {
  background-color: #ff7337;
}
</style>